var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockplayerTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3v11.74l-4.696 4.695h-3.913l-2.437 2.348H6.913v-2.348H3V6.13L4.227 3H21zm-1.565 1.565H6.13v11.74h3.13v2.347l2.349-2.348h4.695l3.13-3.13V4.565zm-3.13 3.13v4.696h-1.566V7.696h1.565zm-3.914 0v4.696h-1.565V7.696h1.565z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ij48L3BhdGg+PHBhdGggZD0iTTIxIDN2MTEuNzRsLTQuNjk2IDQuNjk1aC0zLjkxM2wtMi40MzcgMi4zNDhINi45MTN2LTIuMzQ4SDNWNi4xM0w0LjIyNyAzSDIxem0tMS41NjUgMS41NjVINi4xM3YxMS43NGgzLjEzdjIuMzQ3bDIuMzQ5LTIuMzQ4aDQuNjk1bDMuMTMtMy4xM1Y0LjU2NXptLTMuMTMgMy4xM3Y0LjY5NmgtMS41NjZWNy42OTZoMS41NjV6bS0zLjkxNCAwdjQuNjk2aC0xLjU2NVY3LjY5NmgxLjU2NXoiPjwvcGF0aD48L3N2Zz4=";
export { SvgBlockplayerTwitch as ReactComponent };